export const KE_HOACH_LOAI_KY = {
  THANG: 1,
  NAM: 2,
} as const;

export type KeHoachLoaiKy =
  (typeof KE_HOACH_LOAI_KY)[keyof typeof KE_HOACH_LOAI_KY];

export interface FormatTenKeHoachSuaChuaParams {
  loaiKy?: KeHoachLoaiKy;
  thang?: number | string;
  nam: number | string;
  tenVietTat: string;
  maDanhMuc: string;
}

/**
 * loai_ky=1 (tháng): KHSC.T[thang][nam].[ten_viet_tat].[ma_danh_muc]
 * loai_ky=2 (năm):   KHSC.N[nam].[ten_viet_tat].[ma_danh_muc]
 * - thang: 2 characters (zero-padded month)
 * - nam: 4 characters (year)
 * - ten_viet_tat: CapSuaChua.ten_viet_tat
 * - ma_danh_muc: DanhMucToaXe.ma_danh_muc
 */
export function formatTenKeHoachSuaChua({
  loaiKy = KE_HOACH_LOAI_KY.THANG,
  thang,
  nam,
  tenVietTat,
  maDanhMuc,
}: FormatTenKeHoachSuaChuaParams): string {
  const year = String(nam).padStart(4, "0");
  const shortName = tenVietTat?.trim() || "";
  const categoryCode = maDanhMuc?.trim() || "";

  if (!shortName || !categoryCode) {
    return "";
  }

  if (loaiKy === KE_HOACH_LOAI_KY.NAM) {
    return `KHSC.N${year}.${shortName}.${categoryCode}`;
  }

  const month = String(thang ?? "").padStart(2, "0");

  return `KHSC.T${month}${year}.${shortName}.${categoryCode}`;
}
